import {authRequest} from './index.js'


export async function get_subscription(subscription_id){
  let data
  await authRequest.get(
    'subscriptions/' + subscription_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_subscription_duration(subscription_id){
  let data
  await authRequest.get(
    'subscriptions/' + subscription_id + '/duration'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function update_subscription(id, status){
  let data = ''
  await authRequest.patch(
  `subscriptions/${id}/status`,
    { child_subscription: {status} }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_subscriptions(){
  let data
  await authRequest.get(
    '/subscriptions'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function submit_payment(payments){
  let data = ''
  await authRequest.post(
  '/payments',
    { payments }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}

export async function create_subscription(subscription){
  let data = ''
  await authRequest.post(
  `children/${subscription.child_id}/subscription`,
    { subscription }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}


export async function check_payment(session_id){
  let data = ''
  await authRequest.post(
  '/payments/check',
    { session_id }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}

export async function get_payment_status(payment_id){
  let data = ''
  await authRequest.get(
  `/payments/${payment_id}`
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}

export async function get_invoice(invoice_id){
  let data = ''
  await authRequest.post(
  '/payments/invoice',
    { invoice_id }, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data || error.message}
  })
  return data
}

export async function getPaymentHistory(){
  let data
  await authRequest.get(
    '/payments/history'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function downloadInvoice(paymentId){
  let data
  await authRequest.get(
    `/payments/${paymentId}/download_invoice`,
    { responseType: 'blob' }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}